import { Button } from "@mui/material"
import { authenticationStateLogout } from "fwork.react.apptemplate/src/redux/reducers/authenticationtest.slice"
import * as React from 'react'
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { RoutesNames } from "../../globals"
import { clearAuthorizations } from '../../redux/reducers/authorizations.slice'
import { clearEvents } from '../../redux/reducers/events.slice'
import { clearLocations } from '../../redux/reducers/locations.slice'
import { clearParticipants } from "../../redux/reducers/participants.slice"
import { clearSports } from '../../redux/reducers/sports.slice'
import { clearTournaments } from '../../redux/reducers/tournaments.slice'
import { clearUserGroups } from '../../redux/reducers/userGroups.slice'
import { clearUsersLogs } from '../../redux/reducers/usersLogs.slice'
import { clearUserLogsGroups } from '../../redux/reducers/usersLogsGroups.slice'
import { RootState, clearReducers } from "../../redux/store"
import { clearUsers } from "../../redux/reducers/users.slice"
import { clearDbTasks } from "../../redux/reducers/tasks.slice"

export const AppBarUserOptionsComponent = () => {
  const authenticationState = useSelector((state: RootState) => state.authenticationState)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleLogout = () => {
    clearReducers.forEach(action => dispatch(action()))
    dispatch(authenticationStateLogout())
  }

  return <div aria-label="AppBarUserOptionsComponent"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 10,
    }}
  >
    {authenticationState.payload?.user ?
      <>
        <span style={{
          display: 'flex',
          gap: 10,
          whiteSpace: 'nowrap',
        }}>
          {authenticationState.payload?.user.login},
          <Link
            onClick={handleLogout}
            style={{
              color: 'inherit'
            }}
            to={RoutesNames.home}>
            Sair
          </Link>
        </span>
      </> :
      <Button
        variant="contained"
        onClick={() => {
          // dispatch(authenticationStateLogout())
          handleLogout()
          navigate(RoutesNames.login)
        }}
        style={{
          color: 'inherit',
          // textTransform: 'none',
          backgroundColor: '#2B3467'
        }}>
        Entrar
      </Button>}
  </div>
}